/** Design Only is 10% of the highest quoted package, rounded up to $100. */
export function designOnlyPrice(quotedPrices: readonly number[]): number {
  const validPrices = quotedPrices.filter(price => Number.isFinite(price) && price > 0);
  if (!validPrices.length) return 0;
  return Math.ceil(Math.max(...validPrices) / 1000) * 100;
}

/** Exact 10% of the selected package, rounded only to the nearest cent. */
export function selectedDesignOnlyPrice(total: number): number {
  return Number.isFinite(total) && total > 0 ? Math.round(Math.round(total * 100) / 10) / 100 : 0;
}
